import React, { useEffect } from 'react'
import MainGrid from './MainGrid'
import { useNavigate } from 'react-router-dom'




const Home = ({selectedCategory,setselectedCategory,databaseDataLength,setDatabaseDataLength, mic,setIsDrawerVisible, isDrawerVisible, userDetails, setUserDetails , page, setPage, setLoading, Loading, VedioArr, AllFetchedData, setVedioArr,setAllFetchedData,setDisplayName,displayName}) => {


  const navigate = useNavigate();
  
  useEffect(()=>{


    let data = JSON.parse(localStorage.getItem("userDetails"))
    if(!data || data.name === null)
      {
        navigate('/details')
      }
  },[])

  return (
    <div>
        <MainGrid displayName={displayName} setDisplayName={setDisplayName} VedioArr={VedioArr} setVedioArr={setVedioArr} setAllFetchedData={setAllFetchedData} AllFetchedData={AllFetchedData}  page={page} setPage={setPage} setLoading={setLoading} Loading={Loading}  databaseDataLength={databaseDataLength} setDatabaseDataLength={setDatabaseDataLength}  selectedCategory={selectedCategory} setselectedCategory={setselectedCategory} userDetails={userDetails} setUserDetails={setUserDetails} mic={mic} setIsDrawerVisible={setIsDrawerVisible} isDrawerVisible={isDrawerVisible}/>
    </div>
  )
}

export default Home
